"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConfigurationService = exports.BaseConfigurationService = exports.ConfigurationService = void 0;
const effect_1 = require("effect");
const requests_1 = require("./requests");
const gavelConfig_1 = require("../gavelConfig");
const FetchHttpClient = __importStar(require("@effect/platform/FetchHttpClient"));
const HttpClient = __importStar(require("@effect/platform/HttpClient"));
class ConfigurationService extends effect_1.Context.Tag('@fixtuur/gavel-client/ConfigurationService')() {
}
exports.ConfigurationService = ConfigurationService;
const makeConfigurationService = effect_1.Effect.gen(function* () {
    const config = yield* gavelConfig_1.GavelConfig;
    const http = yield* HttpClient.HttpClient;
    const baseUrl = yield* config.baseUrl;
    const spaces = (tenantId, { productId }) => effect_1.Effect.request(new requests_1.GetSpaces({
        baseUrl,
        tenantId,
        productId
    }), (0, requests_1.GetSpacesResolver)(http));
    const options = (tenantId, selections, { spaceId, filterMode, templateId }) => effect_1.Effect.request(new requests_1.GetOptions({
        baseUrl,
        selections,
        tenantId,
        filterMode,
        spaceId,
        templateId,
    }), (0, requests_1.GetOptionsResolver)(http));
    const selections = (tenantId, proposals, { spaceId, filterMode, templateId }) => effect_1.Effect.request(new requests_1.PostSelections({
        baseUrl,
        proposals,
        tenantId,
        filterMode,
        spaceId,
        templateId,
    }), (0, requests_1.PostSelectionsResolver)(http)).pipe(effect_1.Effect.map(({ options: { properties }, selections }) => ({
        options: properties,
        selections,
    })));
    const configurations = (tenantId, selections, { count, cursor, spaceId, templateId }) => effect_1.Effect.request(new requests_1.GetConfigurations({
        baseUrl,
        selections,
        tenantId,
        count,
        cursor,
        spaceId,
        templateId,
    }), (0, requests_1.GetConfigurationsResolver)(http));
    return { spaces, options, selections, configurations };
});
exports.BaseConfigurationService = effect_1.Layer.effect(ConfigurationService, makeConfigurationService);
exports.DefaultConfigurationService = exports.BaseConfigurationService.pipe(effect_1.Layer.provide(FetchHttpClient.layer));
